import { useScheduleActivityLocale } from '../../activity/hooks';
import { ScheduleActivityReferencePickerPlugin } from '../../activity/types';

const LegacyScheduleActivityCustomOptionLabel: ScheduleActivityReferencePickerPlugin['CustomOptionLabel'] =
  () => {
    const { T } = useScheduleActivityLocale();

    return T.translate('SCHEDULE');
  };

export default LegacyScheduleActivityCustomOptionLabel;
